"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusSteamVRDisconnectedT = exports.StatusSteamVRDisconnected = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * SteamVR bridge is disconnected
 */
class StatusSteamVRDisconnected {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsStatusSteamVRDisconnected(bb, obj) {
        return (obj || new StatusSteamVRDisconnected()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsStatusSteamVRDisconnected(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new StatusSteamVRDisconnected()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    bridgeSettingsName(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startStatusSteamVRDisconnected(builder) {
        builder.startObject(1);
    }
    static addBridgeSettingsName(builder, bridgeSettingsNameOffset) {
        builder.addFieldOffset(0, bridgeSettingsNameOffset, 0);
    }
    static endStatusSteamVRDisconnected(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createStatusSteamVRDisconnected(builder, bridgeSettingsNameOffset) {
        StatusSteamVRDisconnected.startStatusSteamVRDisconnected(builder);
        StatusSteamVRDisconnected.addBridgeSettingsName(builder, bridgeSettingsNameOffset);
        return StatusSteamVRDisconnected.endStatusSteamVRDisconnected(builder);
    }
    unpack() {
        return new StatusSteamVRDisconnectedT(this.bridgeSettingsName());
    }
    unpackTo(_o) {
        _o.bridgeSettingsName = this.bridgeSettingsName();
    }
}
exports.StatusSteamVRDisconnected = StatusSteamVRDisconnected;
class StatusSteamVRDisconnectedT {
    constructor(bridgeSettingsName = null) {
        this.bridgeSettingsName = bridgeSettingsName;
    }
    pack(builder) {
        const bridgeSettingsName = (this.bridgeSettingsName !== null ? builder.createString(this.bridgeSettingsName) : 0);
        return StatusSteamVRDisconnected.createStatusSteamVRDisconnected(builder, bridgeSettingsName);
    }
}
exports.StatusSteamVRDisconnectedT = StatusSteamVRDisconnectedT;
